import React, { useEffect, useState } from 'react'
import InView from 'react-intersection-observer'
import {
	animated,
	useSpring,
	useSpringRef,
	useChain,
	useTransition
} from 'react-spring'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import * as styles from './styles.module.scss'

const Bestseller: React.FC = () => {
	const [startAnimation, setStartAnimation] = useState(false)
	const { t } = useTranslation()

	const pathAnimationRef = useSpringRef()
	const pathAnimationProps = useSpring({
		from: {
			strokeDasharray: 4000,
			strokeDashoffset: 4000
		},
		to: {
			strokeDasharray: 4000,
			strokeDashoffset: 0
		},
		config: { friction: 400 },
		ref: pathAnimationRef
	})

	const imageRef = useSpringRef()
	const imageProps = useSpring({
		from: {
			transform: 'scale(0)'
		},
		to: {
			transform: 'scale(1)'
		},
		ref: imageRef
	})

	const transitionsRef = useSpringRef()
	const transitions = useTransition(
		[
			{
				title: 'Lancôme',
				className: 'h1 font-weight-bold'
			},
			{
				title: 'La Vie Est Belle',
				className: 'display-2 text-primary font-weight-bold'
			}
		],
		{
			from: { opacity: 0, transform: `translateX(100px)` },
			enter: { opacity: 1, transform: `translateX(0)` },
			delay: 1000,
			trail: 200,
			ref: transitionsRef
		}
	)

	useChain(
		startAnimation ? [pathAnimationRef, imageRef, transitionsRef] : [],
		[0, 0.8]
	)

	return (
		<section className="position-relative">
			<svg
				width="1968"
				height="340"
				viewBox="0 0 1968 340"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={styles.line}
			>
				<animated.path
					d="M1967.09 169.377C1627.69 -8.88717 1767.41 235.917 1582.19 104.723C1476.87 30.1336 1363.58 -16.1695 1256.67 7.5346C1199.78 20.1477 1096.23 96.6429 1054.82 128.138C964.192 197.058 950.979 301.673 868.019 260.083C806.041 229.014 796.492 300.672 777.482 330.218C749.065 374.382 641.49 229.811 552.008 249.977C459.003 270.938 474.494 364.199 334.723 233.362C254.135 157.925 161.981 83.8591 0.354006 130.089"
					stroke="#D52878"
					strokeWidth="1.4"
					strokeMiterlimit="10"
					style={pathAnimationProps}
				/>
			</svg>

			<div className="container">
				<h2 className="text-center mt-4 mb-5">{t('bestseller.title')}</h2>
				<div className="row align-items-center">
					<div className="col-sm text-center">
						<animated.img
							src="/2021/images/bestseller.png?v=1"
							alt={t('bestseller.title')}
							className={styles.image}
							style={imageProps}
						/>
					</div>
					<div className="col-sm my-5 text-center">
						<div className="d-inline-block text-start position-relative">
							<p className="h4">{t('bestseller.text')}</p>
							<h3>
								{transitions((style, item) => (
									<animated.div style={style} className={item.className}>
										{item.title}
									</animated.div>
								))}
							</h3>
							<InView
								onChange={(inView) => {
									inView && setStartAnimation(true)
								}}
							>
								<a
									href="https://www.notino.cz/lancome/la-vie-est-belle-parfemovana-voda-pro-zeny/p-85449/"
									className={`btn btn-secondary px-4 py-3 text-uppercase font-weight-bold mt-3 ${styles.button}`}
									target="_blank"
								>
									{t('bestseller.button')}
								</a>
							</InView>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Bestseller
